import random from 'lodash/random';
import isEqual from 'lodash/isEqual';
import replace from 'lodash/replace';
import findKey from 'lodash/findKey';

export const AnalyticsShow = {
    ShareOK:
        'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkpwc&pr=%random%&ptrc=b',
    ShareVK:
        'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkpwd&pr=%random%&ptrc=b',
    ShareTG:
        'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkpwe&pr=%random%&ptrc=b',
    ThemeLight:
        'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkpwi&pr=%random%&ptrc=b',
    ThemeDark:
        'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkpwl&pr=%random%&ptrc=b',
    StoriesBlock:
        'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkpwh&pr=%random%&ptrc=b',
    ScrollBottom:
        'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkpwj&pr=%random%&ptrc=b',
    Tags: {
        photo: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkpwa&pr=%random%&ptrc=b',
        markshader:
            'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkpwp&pr=%random%&ptrc=b',
        private:
            'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkpwk&pr=%random%&ptrc=b',
        work: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkpwg&pr=%random%&ptrc=b',
        messoyakha:
            'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkpwq&pr=%random%&ptrc=b',
        nature: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkpvz&pr=%random%&ptrc=b',
        video: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkpwb&pr=%random%&ptrc=b',
        watch: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkpwf&pr=%random%&ptrc=b',
        rest: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkpwo&pr=%random%&ptrc=b',
    },
};

export const AnalyticsClick = {
    PikabuLogo: 'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=qkpvx&pr=%random%',
};

export const prepareUrl = (url: string): string => {
    return replace(url, '%random%', random(100, 9999999).toString());
};

export const analytics = (url: string): string => {
    if (typeof window !== 'undefined') {
        if (findKey(AnalyticsClick, (value) => isEqual(url, value))) {
            return prepareUrl(url);
        }
        const img = document.createElement('img');
        img.src = prepareUrl(url);
        img.setAttribute('class', 'ad-pixel');
        img.setAttribute('style', 'position: absolute; width: 1px; height: 1px; top: 0;');
        document.body.appendChild(img);
        return '';
    }
};
